module.exports = __webpack_public_path__ + "img/11.461c1bc4.webp";